export default {
  tiles: [
    {
      index: 1,
      backgroundColor: '#005FB9',
      textColor: 'white',
      entityName: 'travel_rewards_smorg',
      eyebrow: 'Smart travel moves',
      eyebrowColor: 'white',
      description:
        'Earn travel rewards now for that trip you know you’ll want to take later',
      buttonText: 'Point the way',
      buttonUrl:
        'https://www.nerdwallet.com/article/travel/why-you-should-get-your-new-travel-card-6-months-ahead-of-your-trip?trk=hp_smorg_travel_hub&trk_copy=hp_smorg_travel_rewards',
    },
    {
      index: 2,
      backgroundColor: '#E3FAF2',
      textColor: 'neutral-darkest',
      entityName: 'mortgages_moving_out_smorg',
      eyebrow: 'MAKE A MOVE',
      eyebrowColor: 'neutral-darker',
      description: 'Dreaming of moving to a place with a bit more space?',
      buttonText: 'MOVING ON OUT',
      buttonUrl:
        'https://www.nerdwallet.com/article/mortgages/consider-moving-out-of-the-city-home-affordability?trk=hp_smorg_make_a_move&trk_copy=hp_smorg_moving_on_out',
    },
    {
      index: 3,
      backgroundColor: '#4C99E6',
      textColor: 'white',
      entityName: 'financial_advisors_smorg',
      eyebrow: 'INVEST IN FUTURE YOU',
      eyebrowColor: 'white',
      description:
        'Considering a financial advisor? See our highest rated options and find the right fit for you and your money.',
      buttonText: 'SEE TOP ADVISORS',
      buttonUrl:
        'https://www.nerdwallet.com/best/investing/financial-advisors?trk=hp_smorg_invest_in_future_you&trk_copy=hp_smorg_see_top_advisors',
    },
    {
      index: 4,
      backgroundColor: '#F5F5F5',
      entityName: 'podcast_guide_smorg',
      eyebrow: 'Worth A Listen',
      eyebrowColor: 'neutral-darker',
      description:
        'Have a money goal? Turn to our SmartMoney podcast for hacks, how-tos and more.',
      buttonText: 'Tune in',
      buttonUrl:
        'https://www.nerdwallet.com/blog/podcast/?trk=hp_smorg_smartmoneypodcast&trk_copy=hpsmartmoneypodcast',
    },
    {
      index: 5,
      backgroundColor: '#E3FAF2',
      textColor: 'neutral-darkest',
      entityName: 'travel_credit_cards_rewards_smorg',
      eyebrow: 'LET’S GET AWAY',
      eyebrowColor: 'neutral-darker',
      description:
        'Ready for an adventure beyond your backyard? Find the smartest travel rewards card for you.',
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: 'ADVENTURE CALLS',
      buttonUrl:
        'https://www.nerdwallet.com/article/travel/top-rewards-credit-card-offers?trk=hp_smorg_lets_get_away&trk_copy=hp_smorg_adventure_calls',
    },
    {
      index: 6,
      backgroundColor: '#4C99E6',
      textColor: 'white',
      entityName: 'sports_credit_card_rewards_smorg',
      eyebrow: 'GAME ON',
      eyebrowColor: 'white',
      description:
        'Love having the latest sports gear? These credit cards offer special rewards, extra perks, and discounts too.',
      buttonText: 'SEE TOP CARDS',
      buttonUrl:
        'https://www.nerdwallet.com/article/credit-cards/best-credit-cards-for-sports-fans-and-athletes?trk=hp_smorg_game_on&trk_copy=hp_smorg_see_top_cards',
    },
  ],
};
